import { Navigate } from 'react-router-dom';
import { useAuth } from './auth/AuthContext';
import LandingPage from './pages/Landing';

/** Root route `/`. Anonymous visitors get the public landing page (the app's
 *  home page — the URL given to Google's OAuth consent screen), rendered
 *  standalone with NO app sidebar. A signed-in visitor is sent to the dashboard
 *  at /home, which carries the app shell and the approval/role checks. Keeping
 *  the root a real page (not a redirect to /login) is what Google's verification
 *  expects from an app home page. */
export default function RootIndex() {
  const { token } = useAuth();
  if (!token) return <LandingPage />;
  return <Navigate to="/home" replace />;
}
